var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 801,
    viewBox: "0 0 1920 801",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_504_3477)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 801,
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2124 -123H0V762H2124V-123Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5 53.9998H177V142.5L88.5 231H0V142.5L88.5 53.9998Z",
    fill: "#D33E56"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1327.5 231C1376.38 231 1416 191.377 1416 142.5C1416 93.6225 1376.38 53.9998 1327.5 53.9998C1278.62 53.9998 1239 93.6225 1239 142.5C1239 191.377 1278.62 231 1327.5 231ZM1327.5 204.45C1361.71 204.45 1389.45 176.714 1389.45 142.5C1389.45 108.286 1361.71 80.5498 1327.5 80.5498C1293.29 80.5498 1265.55 108.286 1265.55 142.5C1265.55 176.714 1293.29 204.45 1327.5 204.45Z",
    fill: "#C00F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770 53.9998H1947V231L1770 53.9998Z",
    fill: "#D34058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 408C0 361.057 18.6482 316.036 51.8421 282.842C85.036 249.648 130.057 231 177 231L0 408C46.9433 408 91.964 389.352 125.158 356.158C158.352 322.964 177 277.943 177 231",
    fill: "#B70E2A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.5 408C314.377 408 354 368.377 354 319.5C354 270.623 314.377 231 265.5 231C216.623 231 177 270.623 177 319.5C177 368.377 216.623 408 265.5 408ZM265.5 381.45C299.714 381.45 327.45 353.714 327.45 319.5C327.45 285.286 299.714 257.55 265.5 257.55C231.286 257.55 203.55 285.286 203.55 319.5C203.55 353.714 231.286 381.45 265.5 381.45Z",
    fill: "#CD1433"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M517.5 171C578.527 171 628 121.527 628 60.5C628 -0.527492 578.527 -50 517.5 -50C456.473 -50 407 -0.527492 407 60.5C407 121.527 456.473 171 517.5 171ZM517.5 137.85C560.219 137.85 594.85 103.219 594.85 60.5C594.85 17.7808 560.219 -16.85 517.5 -16.85C474.781 -16.85 440.15 17.7808 440.15 60.5C440.15 103.219 474.781 137.85 517.5 137.85Z",
    fill: "#CD1433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354 408C354 361.057 372.648 316.036 405.842 282.842C439.036 249.648 484.056 231 531 231L354 408C400.943 408 445.963 389.352 479.157 356.158C512.351 322.964 531 277.943 531 231",
    fill: "#D1364F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.5 231L708 319.5L619.5 408L531 319.5L619.5 231Z",
    fill: "#D0344D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M796.5 408C845.377 408 885 368.377 885 319.5C885 270.623 845.377 231 796.5 231C747.623 231 708 270.623 708 319.5C708 368.377 747.623 408 796.5 408ZM796.5 381.45C830.714 381.45 858.45 353.714 858.45 319.5C858.45 285.286 830.714 257.55 796.5 257.55C762.286 257.55 734.55 285.286 734.55 319.5C734.55 353.714 762.286 381.45 796.5 381.45Z",
    fill: "#B70E2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239 408C1239 361.057 1257.65 316.036 1290.84 282.842C1324.04 249.648 1369.06 231 1416 231L1239 408C1285.94 408 1330.96 389.352 1364.16 356.158C1397.35 322.964 1416 277.943 1416 231",
    fill: "#D11637"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433.7 231H1416V408H1433.7V231Z",
    fill: "#D0334D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1469.1 231H1451.4V408H1469.1V231Z",
    fill: "#D0334D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504.5 231H1486.8V408H1504.5V231Z",
    fill: "#D0334D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1539.9 231H1522.2V408H1539.9V231Z",
    fill: "#D0334D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1575.3 231H1557.6V408H1575.3V231Z",
    fill: "#D0334D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593 231L1770 408H1593V231Z",
    fill: "#D0334D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1858.5 231H1947V319.5L1858.5 408H1770V319.5L1858.5 231Z",
    fill: "#CD2540"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.5 585C314.377 585 354 545.377 354 496.5C354 447.623 314.377 408 265.5 408C216.623 408 177 447.623 177 496.5C177 545.377 216.623 585 265.5 585ZM265.5 558.45C299.714 558.45 327.45 530.714 327.45 496.5C327.45 462.286 299.714 434.55 265.5 434.55C231.286 434.55 203.55 462.286 203.55 496.5C203.55 530.714 231.286 558.45 265.5 558.45Z",
    fill: "#C20F2D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M991 107C1066.66 107 1128 45.6624 1128 -30C1128 -105.663 1066.66 -167 991 -167C915.337 -167 854 -105.663 854 -30C854 45.6624 915.337 107 991 107ZM991 65.9C1043.96 65.9 1086.9 22.9642 1086.9 -30C1086.9 -82.9641 1043.96 -125.9 991 -125.9C938.036 -125.9 895.1 -82.9641 895.1 -30C895.1 22.9642 938.036 65.9 991 65.9Z",
    fill: "#C20F2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354 408L531 585H354V408Z",
    fill: "#C20F2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.7 408H531V585H548.7V408Z",
    fill: "#D33E56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.1 408H566.4V585H584.1V408Z",
    fill: "#D33E56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.499 408H601.799V585H619.499V408Z",
    fill: "#D33E56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.899 408H637.199V585H654.899V408Z",
    fill: "#D33E56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.3 408H672.6V585H690.3V408Z",
    fill: "#D33E56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708 408H885V585L708 408Z",
    fill: "#D9576C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.7 408H885V585H902.7V408Z",
    fill: "#CA1734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.1 408H920.4V585H938.1V408Z",
    fill: "#CA1734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.5 408H955.8V585H973.5V408Z",
    fill: "#CA1734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.9 408H991.2V585H1008.9V408Z",
    fill: "#CA1734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.3 408H1026.6V585H1044.3V408Z",
    fill: "#CA1734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.7 408H1062V585H1079.7V408Z",
    fill: "#E48B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.1 408H1097.4V585H1115.1V408Z",
    fill: "#E48B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.5 408H1132.8V585H1150.5V408Z",
    fill: "#E48B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.9 408H1168.2V585H1185.9V408Z",
    fill: "#E48B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.3 408H1203.6V585H1221.3V408Z",
    fill: "#E48B9A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1327.5 585C1376.38 585 1416 545.377 1416 496.5C1416 447.623 1376.38 408 1327.5 408C1278.62 408 1239 447.623 1239 496.5C1239 545.377 1278.62 585 1327.5 585ZM1327.5 558.45C1361.71 558.45 1389.45 530.714 1389.45 496.5C1389.45 462.286 1361.71 434.55 1327.5 434.55C1293.29 434.55 1265.55 462.286 1265.55 496.5C1265.55 530.714 1293.29 558.45 1327.5 558.45Z",
    fill: "#D4183A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504.5 408L1593 496.5L1504.5 585L1416 496.5L1504.5 408Z",
    fill: "#FD3463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1681.5 408L1770 496.5L1681.5 585L1593 496.5L1681.5 408Z",
    fill: "#FC3362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 585H177V762L0 585Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.5 585H354V673.5L265.5 762H177V673.5L265.5 585Z",
    fill: "#B70E2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354 585C377.243 585 400.26 589.578 421.734 598.473C443.209 607.368 462.721 620.406 479.157 636.842C495.593 653.278 508.631 672.79 517.526 694.265C526.421 715.74 531 738.756 531 762L354 585C354 631.943 372.648 676.964 405.842 710.158C439.036 743.352 484.056 762 531 762",
    fill: "#D54A60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 585H708V762L531 585Z",
    fill: "#D13952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708 585H885L708 762V585Z",
    fill: "#CE2A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062 585C1085.24 585 1108.26 589.578 1129.73 598.473C1151.21 607.368 1170.72 620.406 1187.16 636.842C1203.59 653.278 1216.63 672.79 1225.53 694.265C1234.42 715.74 1239 738.756 1239 762L1062 585C1062 631.943 1080.65 676.964 1113.84 710.158C1147.04 743.352 1192.06 762 1239 762",
    fill: "#C91331"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1327.5 762C1376.38 762 1416 722.377 1416 673.5C1416 624.623 1376.38 585 1327.5 585C1278.62 585 1239 624.623 1239 673.5C1239 722.377 1278.62 762 1327.5 762ZM1327.5 735.45C1361.71 735.45 1389.45 707.714 1389.45 673.5C1389.45 639.286 1361.71 611.55 1327.5 611.55C1293.29 611.55 1265.55 639.286 1265.55 673.5C1265.55 707.714 1293.29 735.45 1327.5 735.45Z",
    fill: "#BD0F2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433.7 585H1416V762H1433.7V585Z",
    fill: "#D0324C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1469.1 585H1451.4V762H1469.1V585Z",
    fill: "#D0324C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504.5 585H1486.8V762H1504.5V585Z",
    fill: "#D0324C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1539.9 585H1522.2V762H1539.9V585Z",
    fill: "#D0324C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1575.3 585H1557.6V762H1575.3V585Z",
    fill: "#D0324C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593 585H1770L1593 762V585Z",
    fill: "#CD2440"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1947 585V762H1770L1947 585Z",
    fill: "#DB1D41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_504_3477"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 801,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.b525afad51378f3053dbe31b2fc4d219.svg";
export { ForwardRef as ReactComponent };